import { landingContent } from "../../data/landingContent";

export function Footer() {
  const { footer } = landingContent;

  return (
    <footer style={{ borderTop: "1px solid rgba(255,255,255,0.05)" }}>
      <div className="st-container">
        {/* Brand Column */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            maxWidth: "320px",
          }}
        >
          <a
            className="st-footer-logo"
            href="/"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              color: "#FFF",
              fontWeight: 800,
              textDecoration: "none",
            }}
          >
            <img
              src="/landing/icon.png"
              alt=""
              aria-hidden="true"
              style={{ width: "20px", height: "20px", borderRadius: "4px" }}
            />
            <span>Stalkie</span>
          </a>
          <p
            className="st-footer-desc"
            style={{ color: "rgba(255,255,255,0.6)", margin: 0 }}
          >
            {footer.description}
          </p>
          <a
            className="st-buildrship-badge"
            href="https://buildrship.xyz/products/stalkie"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://buildrship.xyz/assets/featured-on-buildrship.png"
              alt="Featured on Buildrship"
              width={130}
              height={46}
            />
          </a>
        </div>

        {/* Links Group Column */}
        <div className="st-footer-links-group">
          {/* Product Column */}
          <div>
            <h4
              style={{
                color: "#FFF",
                fontSize: "0.8125rem",
                fontWeight: 800,
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                marginBottom: "12px",
                marginTop: 0,
              }}
            >
              {footer.productTitle}
            </h4>
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              {footer.productLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={
                      link.href.startsWith("#") ? `/${link.href}` : link.href
                    }
                    className="st-footer-link"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4
              style={{
                color: "#FFF",
                fontSize: "0.8125rem",
                fontWeight: 800,
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                marginBottom: "12px",
                marginTop: 0,
              }}
            >
              {footer.companyTitle}
            </h4>
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              {footer.companyLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="st-footer-link">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Column */}
          <div>
            <h4
              style={{
                color: "#FFF",
                fontSize: "0.8125rem",
                fontWeight: 800,
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                marginBottom: "12px",
                marginTop: 0,
              }}
            >
              {footer.legalTitle}
            </h4>
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              {footer.legalLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="st-footer-link">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright & Disclaimer Row */}
      <div
        className="st-container"
        style={{
          display: "block",
          borderTop: "1px solid rgba(255,255,255,0.05)",
          paddingTop: "20px",
          marginTop: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            gap: "8px",
            textAlign: "center",
          }}
        >
          <p
            style={{
              color: "rgba(255,255,255,0.4)",
              fontSize: "0.75rem",
              margin: 0,
              fontWeight: 500,
              textAlign: "center",
            }}
          >
            &copy; {new Date().getFullYear()} Stalkie.{" "}
            {footer.allRightsReserved}
          </p>
          <p
            style={{
              color: "rgba(255,255,255,0.25)",
              fontSize: "0.6875rem",
              margin: 0,
              lineHeight: 1.4,
              fontWeight: 500,
              textAlign: "center",
            }}
          >
            {footer.disclaimer}
          </p>
        </div>
      </div>
    </footer>
  );
}
